// Import dependencies
import React, { useState } from "react";
import emailjs from "emailjs-com";
import { Input, Button, Space, message, Divider, Card, Modal } from "antd";
import { CheckCircleOutlined, MailOutlined, PlusOutlined } from "@ant-design/icons";

export default function AdminJobMailer() {
  const [name, setName] = useState("");
  const [recipients, setRecipients] = useState([{ role: "", email: "" }]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleChange = (index, field, value) => {
    const updated = [...recipients];
    updated[index][field] = value;
    setRecipients(updated);
  };

  const addRecipient = () => {
    setRecipients([...recipients, { role: "", email: "" }]);
  };

  const sendEmails = () => {
    if (!name.trim()) {
      message.error("Please enter your name.");
      return;
    }

    let allSuccessful = true;
    let total = recipients.length;
    let completed = 0;

    recipients.forEach((r, i) => {
      if (!r.email || !r.role) {
        message.warning(`Missing email or role in row ${i + 1}`);
        allSuccessful = false;
        completed++;
        if (completed === total) setShowSuccessModal(true);
        return;
      }

      emailjs
        .send(
          "service_kfv2nsv",
          "template_12lr1v2",
          {
            name: name,
            roleName: r.role,
            email: r.email,
          },
          "aYiVMrWRJdxToo1T3"
        )
        .then(() => {
          completed++;
          if (completed === total) setShowSuccessModal(true);
        })
        .catch(() => {
          message.error(`Failed to send to ${r.email}`);
          completed++;
          if (completed === total) setShowSuccessModal(true);
        });
    });
  };

  return (
    <div style={{ marginTop: 40, padding: 24, background: "linear-gradient(to right, #e0f7fa, #f0f5ff)", borderRadius: 12 }}>
      <Divider orientation="left" style={{ fontWeight: 600 }}>
        <MailOutlined style={{ marginRight: 8 }} /> Job Application Mail Sender
      </Divider>

      <Card bordered style={{ backgroundColor: "#ffffff", boxShadow: "0 4px 16px rgba(0,0,0,0.1)", borderRadius: 10 }}>
        <Space direction="vertical" style={{ width: "100%" }} size="large">
          <Input
            placeholder="Your Name (will be used in all mails)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ borderColor: "#1890ff", borderRadius: 6 }}
          />

          {recipients.map((r, i) => (
            <Space key={i} style={{ display: "flex", width: "100%" }}>
              <Input
                placeholder="Role Name"
                value={r.role}
                onChange={(e) => handleChange(i, "role", e.target.value)}
                style={{ width: "50%", borderRadius: 6 }}
              />
              <Input
                placeholder="Recipient Email"
                value={r.email}
                onChange={(e) => handleChange(i, "email", e.target.value)}
                style={{ width: "50%", borderRadius: 6 }}
              />
            </Space>
          ))}

          <Button icon={<PlusOutlined />} onClick={addRecipient} style={{ width: "fit-content", borderRadius: 6 }}>
            Add Another Recipient
          </Button>

          <Button type="primary" onClick={sendEmails} icon={<MailOutlined />} style={{ borderRadius: 6 }}>
            Send Emails
          </Button>
        </Space>
      </Card>

      <Modal
        title="Emails Sent Triggered!"
        open={showSuccessModal}
        onOk={() => setShowSuccessModal(false)}
        onCancel={() => setShowSuccessModal(false)}
        okText="OK"
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <p>Email sending process has been triggered for all listed recipients.</p>
      </Modal>
    </div>
  );
}
